import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import ClientsList from './pages/ClientsList.js';
import ClientEdit from './pages/ClientEdit.js';
import ClientDetail from './pages/ClientDetail.js';
import SubmissionsList from './pages/SubmissionsList.js';
import SubmissionDetail from './pages/SubmissionDetail.js';
import AuditLog from './pages/AuditLog.js';
import FailuresList from './pages/FailuresList.js';
import LoginPage from './pages/LoginPage.js';
import DocsUsage from './pages/DocsUsage.js';
import DocsMcp from './pages/DocsMcp.js';
import SitesList from './pages/SitesList.js';
import SiteDetail from './pages/SiteDetail.js';
import FormEdit from './pages/FormEdit.js';

const API_ORIGIN = 'https://forms.conversionhive.au';

async function fetchMe(): Promise<string | null> {
  try {
    const res = await fetch(`${API_ORIGIN}/auth/me`, { credentials: 'include' });
    if (!res.ok) return null;
    const data = await res.json() as { ok: boolean; email?: string };
    return data.ok ? (data.email ?? null) : null;
  } catch {
    return null;
  }
}

async function logout() {
  await fetch(`${API_ORIGIN}/auth/logout`, { method: 'POST', credentials: 'include' });
  window.location.reload();
}

export default function App() {
  const [email, setEmail] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    fetchMe().then(setEmail);
  }, []);

  if (email === undefined) return null; // loading

  if (email === null) return <LoginPage />;

  return (
    <BrowserRouter>
      <div className="layout">
        <aside className="sidebar">
          <div className="sidebar-brand">Form Handler</div>
          <nav>
            <NavLink to="/clients">Clients</NavLink>
            <NavLink to="/sites">Sites</NavLink>
            <NavLink to="/failures">Failed submissions</NavLink>
            <NavLink to="/audit">Audit Log</NavLink>
            <NavLink to="/docs/usage">Usage guide</NavLink>
            <NavLink to="/docs/mcp">MCP (AI integration)</NavLink>
          </nav>
        </aside>

        <div className="main">
          <div className="topbar">
            <span>{email}</span>
            <button onClick={logout} style={{ marginLeft: 'auto', cursor: 'pointer', background: 'none', border: '1px solid #ccc', padding: '4px 12px', borderRadius: '4px', fontSize: '13px' }}>
              Sign out
            </button>
          </div>
          <div className="page">
            <Routes>
              <Route path="/" element={<ClientsList />} />
              <Route path="/clients" element={<ClientsList />} />
              <Route path="/clients/new" element={<ClientEdit />} />
              <Route path="/clients/:id/edit" element={<ClientEdit />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/clients/:clientId/submissions" element={<SubmissionsList />} />
              <Route path="/submissions/:id" element={<SubmissionDetail />} />
              <Route path="/audit" element={<AuditLog />} />
              <Route path="/failures" element={<FailuresList />} />
              <Route path="/docs/usage" element={<DocsUsage />} />
              <Route path="/docs/mcp" element={<DocsMcp />} />
              <Route path="/sites" element={<SitesList />} />
              <Route path="/sites/:id" element={<SiteDetail />} />
              <Route path="/forms/:id" element={<FormEdit />} />
            </Routes>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
}
